import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup, Badge } from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import UserChips from '../UserChips';
import { Flag } from 'flagger/react'
import { getAll as getAllUsers} from '../../services/userService'

class EditPrinterDestinationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      lang: '',
      destination: {},
      folder: {},
      clients: [],
      printers: [],
      selectedPrintClient: {},
      selectedDestination: {},
      selectedPrinter: [],
      printersarray: [],
      usersarray: [],
      usernames: []
    }

    this.handlePrintDropdownChange = this.handlePrintDropdownChange.bind(this)
    this.getX3PrinterClients = this.getX3PrinterClients.bind(this);
    this.getX3Printers = this.getX3Printers.bind(this);
    this.saveDestination = this.saveDestination.bind(this);
    this.togglePrintersModal = this.togglePrintersModal.bind(this);
    this.remove = this.remove.bind(this);
  }

  componentDidMount() {
    this.formIsLoading();
    fetch(window.location.protocol + '//' + window.location.host + '/api/printing/x3printer?id=' + this.props.destination)
      .then(res => res.json())
      .then(result => {
        result.printers.forEach((printer, i) => {
          var printerObj = {
            'id': i,
            'print_name': printer.print_name,
            'print_client_name': printer.print_client_name,
            'watermark': printer.watermark,
            'print_count': printer.print_count
          }

          this.setState(prevState => ({
            printersarray: prevState.printersarray.concat(printerObj)
          }))
        });

        this.setState({
          textGroup: result.group_name,
          destination: result,
          selectedFolder: result.folder,
          selectedDestination: result.destination_name,
          usersarray: result.printer_users
          // selectedPrintClient: result.print_client_name,
          // selectedPrinter: result.printers,
          // printersarray: result.printers
        });
        //set the fields.
        this.getX3PrinterClients();
        this.getX3Printers(result.print_client_name);
        this.getUsers();
      });
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.selectedPrintClient != this.state.selectedPrintClient) {
      this.formIsLoading();
      this.getX3Printers(this.state.destination.print_client_name);
    }
  }

  formIsLoading() {
    this.setState({ isLoading: true });
  }

  getUsers = async () => {
    const result = await getAllUsers({ isActive : true});
    let usernames = [];
    for (const u of result.data) {
      usernames.push(u.username);
    }
    this.setState({usernames: usernames});
  }

  saveDestination() {
    try {
      var bdy = {};
      bdy.id = this.props.destination;
      bdy.name = this.state.textGroup;
      bdy.destination = this.state.selectedDestination;
      bdy.folder = this.state.selectedFolder;
      //bdy.client = selectedPrintClient;
      bdy.printers = this.state.printersarray;
      bdy.printer_users = this.state.usersarray;

      fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printers",
        {
          method: "PUT",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bdy)
        })
        .then(res => res.json())
        .then(result => {
          this.props.alert.success("Updated destination");
          this.props.toggle()
          this.props.refresh();
        })
    }
    catch (error) {
      this.props.alert.error(error.message);
    }
  }

  handlePrintDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const id = target.id;

    var found = this.state.printersarray.find(element => {
      return element.id == id;
    });

    if (!this.state.printersarray.includes(found)) {
      var printerObj = {
        'id': this.state.printersarray.length,
        'print_name': '',
        'print_client_name': '',
        'watermark': '',
        'print_count': '0'
      }

      this.setState(prevState => ({
        printersarray: prevState.printersarray.concat(printerObj)
      }))
    }
    else {
      found[name] = value;

      var newArray = this.state.printersarray;
      newArray.splice(id, 1, found);

      this.setState({
        printersarray: newArray
      })
    }
  }

  getX3PrinterClients() {
    fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printerclients")
      .then(res => res.json())
      .then(result => {
        this.setState({
          clients: result.clients,
          isLoading: false
        })
      })
  }

  getX3Printers(client) {
    fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printers?client=" + client)
      .then(res => res.json())
      .then(result => {
        this.setState({
          printers: result.printers,
          isLoading: false
        })
      })
  }
  

  togglePrintersModal() {
    var newArray = this.state.printersarray.slice();
    var printerObj = {
      'id': this.state.printersarray.length,
      'print_name': '',
      'print_client_name': '',
      'watermark': '',
      'print_count': '0'
    }
    newArray.push(printerObj);
    this.setState({ printersarray: newArray })
  }

  remove(id) {
    // create new array and re-assign ids on remove
    var newArray = [];
    var newid = 0;

    this.state.printersarray.forEach((printer, i) => {
      if (i != id) {
        var printerObj = {
          'id': newid,
          'print_name': printer.print_name,
          'print_client_name': printer.print_client_name,
          'watermark': printer.watermark,
          'print_count': printer.print_count
        }
        newArray.push(printerObj);
        newid++;
      }
    });

    this.setState({ printersarray: newArray })
  }

  addUser = (name) => {
    let users = this.state.usersarray;

    if (!users.includes(name))
      users.push(name);

    this.setState({
      usersarray: users
    })
  }

  removeUser = (name) => {
    let users = this.state.usersarray.filter(u => u !== name)
    this.setState({
      usersarray: users
    })
  }

  render() {
    const { localisation } = this.props.userReducer;
    const { isLoading, clients: clientsData, printersarray } = this.state;
  
    /* ---------- helpers ---------- */
  
    // 1. <option> list that appears in *every* “client” <select>
    const sharedClientOptions = [
      <option key="_blank" value="">
        {localisation['default_select_text']
          ? localisation['default_select_text'].element_lang
          : 'Select...'}
      </option>,
      ...clientsData.flatMap(c => {
        const name = Object.keys(c)[0]; 
        return (
          <option key={name} value={name}>
            {name}
          </option>
        );
      }),
    ];
  
    // 2. Build one <Row> per printer in state
    const printersarraylist = printersarray.map((printer, i) => {
      /* find the object that owns this client so we can list its printers */
      const clientMatch = printer.print_client_name
        ? clientsData.find(c => c[printer.print_client_name])
        : null;
  
      /* turn the printer names into <option> nodes */
      const printerOptions = [
        <option key="_blank" value="">
          {localisation['default_select_text']
            ? localisation['default_select_text'].element_lang
            : 'Select...'}
        </option>,
        ...(clientMatch
          ? (clientMatch[printer.print_client_name][0].printers || []).map(p => (
              <option key={p} value={p}>
                {p}
              </option>
            ))
          : []),
      ];

      return (
        <Row key={i} form>
          {/* ---- print client ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`print_client_name_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['client_name_text']
                  ? localisation['client_name_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="select"
                name="print_client_name"
                id={i}
                value={printer.print_client_name}
                onChange={this.handlePrintDropdownChange}
              >
                {sharedClientOptions}
              </Input>
            </FormGroup>
          </Col>
  
          {/* ---- printer ---- */}
          <Col md={4}>
            <FormGroup>
              <Label
                htmlFor={`print_name_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['printer_name_text']
                  ? localisation['printer_name_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="select"
                name="print_name"
                id={i}
                value={printer.print_name}
                onChange={this.handlePrintDropdownChange}
              >
                {printerOptions}
              </Input>
            </FormGroup>
          </Col>
  
          {/* ---- watermark ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`watermark_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['watermark_text']
                  ? localisation['watermark_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="text"
                name="watermark"
                id={i}
                value={printer.watermark}
                onChange={this.handlePrintDropdownChange}
              />
            </FormGroup>
          </Col>
  
          {/* ---- copies ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`print_count_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['copies_text']
                  ? localisation['copies_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="text"
                name="print_count"
                id={i}
                value={printer.print_count}
                onChange={this.handlePrintDropdownChange}
              />
            </FormGroup>
          </Col>
  
          {/* ---- remove button ---- */}
          <Col md={2}>
            <FormGroup>
              <Button
                className="navbtn s-fonticon-btn"
                outline
                color="danger"
                style={{ marginTop: '25px', padding: '3px 7px' }}
                onClick={() => this.remove(i)}
              >
                
              </Button>
            </FormGroup>
          </Col>
        </Row>
      );
    });
  
    /* ---------- loader ---------- */
    const loading = isLoading ? (
      <Progress animated color="info" value={100} />
    ) : null;
      
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
        <ModalHeader toggle={this.props.toggle}>{localisation['edit_print_destination'] ? localisation['edit_print_destination'].element_lang : ''}</ModalHeader>
        <ModalBody>
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="groupName" className="s-field-title s-anchored">{localisation['table_header_name'] ? localisation['table_header_name'].element_lang : ''}</Label>
                <Input value={this.state.textGroup} disabled type="text" name={"textGroup"} id={"textGroup"}></Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="selectedFolder" className="s-field-title s-anchored">{localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''}</Label> {/*<Bug 11681:Destination listed twice in edit printer destination*/}
                <Input value={this.state.selectedFolder} disabled type="text" name={"selectedFolder"} id={"selectedFolder"}></Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="selectedDestination" className="s-field-title s-anchored">{localisation['table_header_destination'] ? localisation['table_header_destination'].element_lang : ''}</Label>
                <Input value={this.state.selectedDestination} disabled type="text" name={"selectedDestination"} id={"selectedDestination"}></Input>
              </FormGroup>
            </Col>
            {}
            {}
          </Row>
          <Flag flag="PrintByUser" entity={{ id: 1 }} case="on">
            <header class="s-h2-head-search"><div title="Printers" class="s-h2-title">{localisation['users_text'] ? localisation['users_text'].element_lang : 'Users'}</div></header>
            <UserChips
              usernames={this.state.usernames}
              users={this.state.usersarray}
              handleDelete={this.removeUser}
              addUser={this.addUser}
            />
          </Flag>
          <header class="s-h2-head-search"><div title="Printers" class="s-h2-title">{localisation['printers_text'] ? localisation['printers_text'].element_lang : 'Printers'}</div></header>
          {printersarraylist}
          {loading}
        </ModalBody>
        <ModalFooter>
          <Button color="success" style={{ position: 'absolute', left: '20px' }} onClick={this.togglePrintersModal}>{localisation['add_printer_button'] ? localisation['add_printer_button'].element_lang : ''}</Button>
          <Button color="primary" onClick={() => this.saveDestination(this.state.selectedFolder, this.state.selectedDestination, this.state.selectedPrintClient, this.state.selectedPrinter)}>{localisation['save_button'] ? localisation['save_button'].element_lang : ''}</Button>
          <Button color="secondary" onClick={this.props.toggle}>{localisation['cancel_button'] ? localisation['cancel_button'].element_lang : ''}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(state => state)(withAlert()(EditPrinterDestinationModal));